import { observer } from 'mobx-react';
import React, { ChangeEvent, FC } from 'react';
import { SHORT_PLAIN_TEXT_LENGTH } from '../../../constans/common-constants';
import ResponseEntity from '../../../store/polls-store/response-entity';
import ActionButton from '../../shared/action-button/action-button';
import AutoTextArea from '../../shared/auto-textarea/auto-textarea';

interface IProps {
  response: ResponseEntity;
  deleteResponseById: (id: string) => void;
  validation: (isValid: boolean) => void;
}

const PollResponseListItem: FC<IProps> = observer(({ response, deleteResponseById, validation }) => {
  const isResponseAllowedLength = response.value.length <= SHORT_PLAIN_TEXT_LENGTH;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    response.setValue(e.target.value);

    const isResponseValid = !response.checkIsResponseValid();
    validation(isResponseValid);
  };

  return (
    <div className='draggable-element'>
      <AutoTextArea
        name='value'
        className='manage-poll-response-input'
        placeholder='Enter response…'
        onChange={handleChange}
        value={response.value}
        autoFocus={true}
        hasError={!isResponseAllowedLength}
        enableAutoFocus={true}
      />
      <ActionButton
        customClasses='remove-button close-icon-red'
        onClick={deleteResponseById.bind(null, response.pollChoiceId)}
      />
    </div>
  );
});

export default PollResponseListItem;
